import React from 'react';
import '../style.css';
import { 
  FaBrain, 
  FaBaby, 
  FaFemale, 
  FaUserMd, 
  FaCheck, 
  FaArrowRight,
  FaPlus,
  FaStethoscope,
  FaHeartbeat,
  FaHospital,
  FaMicroscope
} from 'react-icons/fa';

const AboutSection = () => {
  const images = [
    'https://www.beaconhospital.ie/wp-content/uploads/2021/01/Beacon-Hospital-Brain-Surgery-Orbeye.jpg',
    'image.png',
    'image0.png',
    'image2.png'
  ];

  const services = [
    {
      title: 'Best Neurosurgeon',
      description: 'Advanced brain treatments',
      icon: <FaBrain />,
      color: '#1e3a8a'
    },
    {
      title: 'Infertility Care',
      description: 'Fertility treatments',
      icon: <FaBaby />,
      color: '#dc2626'
    },
    {
      title: 'Maternal Health',
      description: 'Prenatal care',
      icon: <FaFemale />,
      color: '#059669'
    },
    {
      title: 'Neurology',
      description: 'Expert treatments',
      icon: <FaUserMd />,
      color: '#7c3aed'
    }
  ];

  const features = [
    { icon: <FaStethoscope />, text: 'Advanced Diagnostics' },
    { icon: <FaHeartbeat />, text: 'Critical Care' },
    { icon: <FaHospital />, text: 'Modern Facilities' },
    { icon: <FaMicroscope />, text: 'Research & Innovation' }
  ];

  return (
    <section className="about-section" id="about">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <div className="section-badge">
            <span className="badge-text">About Our Center</span>
            <div className="badge-line"></div>
          </div>
          <h2 className="section-title">
            Rockland Neuro & Mother Child Health Centre
          </h2>
        </div>

        <div className="about-content">
          {/* Left Side - Image Gallery */}
          <div className="image-column">
            <div className="main-image-container">
              <div className="main-image">
                <img 
                  src={images[0]} 
                  alt="Neuro Care Center" 
                  className="featured-img"
                />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <FaHospital className="overlay-icon" />
                    <span className="overlay-text">Advanced Healthcare</span>
                  </div>
                </div>
              </div>
              {/* Thin Bottom Bar */}
              <div className="image-bottom-bar">
                <div className="bar-left"></div>
                <div className="bar-center"></div>
                <div className="bar-right"></div>
              </div>
            </div>
            
            {/* Equal Size Image Grid */}
            <div className="equal-image-grid">
              {images.slice(1).map((img, index) => (
                <div key={index} className="equal-grid-item">
                  <div className="equal-image-wrapper">
                    <img src={img} alt={`Medical ${index + 1}`} />
                    <div className="equal-overlay">
                      <FaPlus className="equal-plus-icon" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="content-column">
            <div className="content-wrapper">
              <h3 className="content-title">
                Excellence in Neuro & Mother-Child Healthcare
              </h3>
              
              <div className="description-box">
                <p className="description">
                  At Rockland Neuro & Mother Child Health Centre, we are dedicated to providing exceptional healthcare services in the fields of neurology, neurosurgery, infertility, and maternal health. With a team of highly skilled neurosurgeons, neuro specialists, and top infertility doctors in Varanasi, we ensure advanced medical care tailored to each patient's needs.
                </p>
                
                {/* Features with React Icons */}
                <div className="features-grid">
                  {features.map((feature, index) => (
                    <div key={index} className="feature-item">
                      <div className="feature-icon-wrapper">
                        {feature.icon}
                      </div>
                      <span className="feature-text">{feature.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Compact Cards Grid */}
        <div className="compact-cards-section">
          <div className="cards-header">
            <h4 className="cards-title">
              <FaCheck className="title-icon" />
              Our Specialized Services
            </h4>
            <p className="cards-subtitle">
              Comprehensive healthcare services
            </p>
          </div>
          
          {/* Compact Cards Grid */}
          <div className="compact-cards-grid">
            {services.map((service, index) => (
              <div 
                key={index} 
                className="compact-card"
                style={{ '--card-color': service.color }}
              >
                <div className="compact-card-inner">
                  <div className="compact-icon">
                    {service.icon}
                  </div>
                  <div className="compact-content">
                    <h5 className="compact-title">{service.title}</h5>
                    <p className="compact-desc">{service.description}</p>
                  </div>
                </div>
                <div className="compact-hover"></div>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="about-actions">
            <button className="about-btn primary">
              <span>Meet Specialists</span>
              <FaArrowRight className="btn-arrow" />
            </button>
            <button className="about-btn secondary">
              <span>View Facilities</span>
              <FaPlus className="btn-plus" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;